// ─────────────────────────────────────────────────────────────
// Central place for environment-based configuration.
// Change the API domain ONLY in the .env file (REACT_APP_API_URL).
// ─────────────────────────────────────────────────────────────

// Removes spaces and any trailing "/" so we never build URLs like "https://x.com//getStore"
const clean = (value) => (value || "").trim().replace(/\/+$/, "");

// export const API_BASE_URL = clean(process.env.REACT_APP_API_URL) || "https://api.fivlia.com";
export const API_BASE_URL = "https://api.fivlia.com";

if (!API_BASE_URL) {
  // Fail loudly so a missing/typo'd env variable is caught immediately
  throw new Error(
    "REACT_APP_API_URL is not set. Add it to your .env file, e.g. REACT_APP_API_URL=https://api.fivlia.co.in, then restart the dev server."
  );
}
